import React from "react";
import NumberInput from "../../../common/NumberInput";
import Button from "../../../common/Button";
import Row from "../../../common/Row";
import PropTypes from "prop-types";

const BerekenXYComponent = props => {
	const {
		onGetGeoCoordinates,
		disabled,
		breedtegraad,
		breedtegraadField,
		lengtegraad,
		lengtegraadField,
		onChange,
		errorBreedtegraad,
		errorLengtegraad,
		validationMessageType
	} = props;

	return (
		<Row>
			<div className="o-col-4">
				<Button
					disabled={disabled}
					text="Positioneer op de kaart"
					onClick={onGetGeoCoordinates}
				/>
			</div>
		</Row>
	);
};

BerekenXYComponent.propTypes = {
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	onGetGeoCoordinates: PropTypes.func.isRequired,
	breedtegraadField: PropTypes.string.isRequired,
	breedtegraad: PropTypes.number,
	lengtegraadField: PropTypes.string.isRequired,
	lengtegraad: PropTypes.number,
	errorBreedtegraad: PropTypes.string,
	errorLengtegraad: PropTypes.string,
	validationMessageType: PropTypes.string
};

export default BerekenXYComponent;